import { Menu, Layout } from 'antd';
import { menuItems, NavSubsection } from '../../../utils/utils';
import './Navbar.less';
import { useNavigate } from 'react-router-dom';

const { Header } = Layout;
/**
 * @component Navbar.tsx
 * @description Navbar component.
 * @return { Component }
 */
interface NavbarProps {
  itemsCallback: (item: string) => void;
  showItems: boolean;
  subsection?: NavSubsection;
  currentScreen?: string;
}
function Navbar(props: NavbarProps) {
  let navigate = useNavigate();
  //@ts-ignore
  const user = JSON.parse(localStorage.getItem('currentUser'))

  return (
    <Header className="org-navbar-header">
      <div className="org-navbar-logo" onClick={()=> navigate("/dashboard")}/>
      <Menu
        className="org-navbar-menu"
        mode="horizontal"
        onClick={({ key }) => {
          props.itemsCallback(key);
        }}
        inlineIndent={0}
        defaultSelectedKeys={props.currentScreen ? [props.currentScreen] : ['']}
        items={menuItems(props.showItems, user, props.subsection)}
      />
    </Header>
  );
}

export default Navbar;
